import { Language } from "@amcharts/amcharts4/core";
import axios from "axios";
import { APIURL, LANGUAGES } from "./util/constant";

const instance = axios.create();

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    let lang = localStorage.getItem("i18nextLng");

    if (!lang) lang = LANGUAGES.English;

    config.baseURL = APIURL;
    config.headers["Authorization"] = `Bearer ${token}`;

    switch (lang) {
      case LANGUAGES.Turkish:
        config.headers["Accept-Language"] = lang;
        break;
      case LANGUAGES.English:
        config.headers["Accept-Language"] = lang;
        break;
      case LANGUAGES.Arabic:
        config.headers["Accept-Language"] = Language.English;
        break;
      case LANGUAGES.French:
        config.headers["Accept-Language"] = Language.English;
        break;
      case LANGUAGES.German:
        config.headers["Accept-Language"] = Language.English;
        break;
      case LANGUAGES.Russian:
        config.headers["Accept-Language"] = Language.English;
        break;
      case LANGUAGES.Spanish:
        config.headers["Accept-Language"] = Language.English;
        break;
      default:
        config.headers["Accept-Language"] = lang;
        break;
    }

    const blobPaths = [
      "api/file/get/",
      "api/certification/get/",
      "api/organization/export-my-team",
      "api/training/export-potential-trainings",
      "api/training/export-all-registered-trainings",
      "api/invoice/export-invoice",
      "api/employee-360/export-training-scores",
    ];

    if (blobPaths.some((z) => config.url.indexOf(z) > -1))
      config.responseType = "blob";

    return config;
  },
  (error) => {
    // console.dir(error);
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    // console.dir(response.headers);
    return response;
  },
  function (error) {
    // TODO : remove
    // console.log("Response Error : " + error);
    return Promise.reject(error);
  }
);

export const api = instance;
